import React, { FC } from 'react';

import { BUTTON_TYPES, EvBodyMedium, EvFlexColumn } from '@evinced-private/ui-common';

import { PlatformPopup } from 'src/common/components/platform-popup/PlatformPopup';

import { DISCARD_LABEL_CHANGES_MODAL_LABELS } from './DiscardLabelChangesModal.labels';
import { DiscardLabelChangesModalProps } from './DiscardLabelChangesModal.types';

export const DiscardLabelChangesModal: FC<DiscardLabelChangesModalProps> = ({
	onDiscard,
	onKeepEditing
}) => {
	return (
		<PlatformPopup
			isControlled
			isOpen
			title={DISCARD_LABEL_CHANGES_MODAL_LABELS.TITLE}
			onClose={onKeepEditing}
			buttons={[
				{
					onClick: onDiscard,
					title: DISCARD_LABEL_CHANGES_MODAL_LABELS.DISCARD,
					type: BUTTON_TYPES.SECONDARY
				},
				{
					onClick: onKeepEditing,
					title: DISCARD_LABEL_CHANGES_MODAL_LABELS.KEEP_EDITING,
					type: BUTTON_TYPES.PRIMARY
				}
			]}
		>
			<EvFlexColumn gap="MEDIUM">
				<EvBodyMedium>{DISCARD_LABEL_CHANGES_MODAL_LABELS.BODY}</EvBodyMedium>
			</EvFlexColumn>
		</PlatformPopup>
	);
};
